var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_285_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.5C38.531 49.5 49.5 38.531 49.5 25C49.5 11.469 38.531 0.5 25 0.5C11.469 0.5 0.5 11.469 0.5 25C0.5 38.531 11.469 49.5 25 49.5Z",
    stroke: "#183883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 19V16.5C20.25 15.837 20.5134 15.2011 20.9822 14.7322C21.4511 14.2634 22.087 14 22.75 14H27.75C28.413 14 29.0489 14.2634 29.5178 14.7322C29.9866 15.2011 30.25 15.837 30.25 16.5V19M14 26.5C17.4895 28.2584 21.3425 29.1743 25.25 29.1743C29.1575 29.1743 33.0105 28.2584 36.5 26.5M14 21.5C14 20.837 14.2634 20.2011 14.7322 19.7322C15.2011 19.2634 15.837 19 16.5 19H34C34.663 19 35.2989 19.2634 35.7678 19.7322C36.2366 20.2011 36.5 20.837 36.5 21.5V32.75C36.5 33.413 36.2366 34.0489 35.7678 34.5178C35.2989 34.9866 34.663 35.25 34 35.25H16.5C15.837 35.25 15.2011 34.9866 14.7322 34.5178C14.2634 34.0489 14 33.413 14 32.75V21.5Z",
    stroke: "#183883",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9319 22.5824L26.7813 23.0824H23.2075L23.3552 22.5824H26.9319ZM25.4859 27L23.2529 24.3778L23.2473 24.0114H24.2245C24.52 24.0114 24.7719 23.9687 24.9802 23.8835C25.1885 23.7964 25.3476 23.6676 25.4575 23.4972C25.5692 23.3267 25.6251 23.1155 25.6251 22.8636C25.6251 22.4924 25.5086 22.2008 25.2757 21.9886C25.0446 21.7746 24.7132 21.6676 24.2813 21.6676H23.2075L23.3552 21.1818H24.2813C24.698 21.1818 25.0465 21.2538 25.3268 21.3977C25.609 21.5417 25.8211 21.7405 25.9632 21.9943C26.1071 22.2462 26.1791 22.536 26.1791 22.8636C26.1791 23.1705 26.1099 23.447 25.9717 23.6932C25.8353 23.9375 25.6242 24.1316 25.3382 24.2756C25.0541 24.4176 24.6914 24.4886 24.2501 24.4886H24.0456L26.1478 26.9574V27H25.4859ZM26.9518 21.1818L26.8041 21.6818L23.7927 21.6676L23.9291 21.1818H26.9518Z",
    fill: "#183883"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_285_127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentAccount);
export default __webpack_public_path__ + "static/media/CurrentAccount.5add53f5e7d5d1126fc83008cd96ebec.svg";
export { ForwardRef as ReactComponent };